import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-reviewsSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			new Swiper (el.querySelector('.b-reviewsSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 16,
				slideClass: 'b-reviewsSlider-item',
				navigation : {
					nextEl : el.querySelector('.b-sliderArrows-btn_next'),
					prevEl : el.querySelector('.b-sliderArrows-btn_prev')
				},
				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 16,
					},
					480: {
						slidesPerView: 2,
						spaceBetween: 16,
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 40,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
					1380: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},
			});
		});
	});
});
